import { watch } from 'vue'
import { i18n } from '@/i18n'
import { useEffectiveLocale } from '@/composables/useEffectiveLocale'
import { useAccountPreferencesStore } from '@/stores/accountPreferences'
import { useAuthStore } from '@/stores/auth'

/**
 * ADR-010 D3: applies the derived effective locale to `vue-i18n` and `<html lang>`; the only writer
 * of the active locale. Also loads the account preferences after sign-in and clears them (and the
 * per-origin hint) when the member signs out.
 */
export function useLocaleSync(): void {
  const { effectiveLocale } = useEffectiveLocale()
  const preferences = useAccountPreferencesStore()
  const auth = useAuthStore()

  // `watch`, not `watchEffect`: vue-i18n's locale setter reads its own state, which an effect
  // would track and re-trigger on.
  watch(
    effectiveLocale,
    locale => {
      i18n.global.locale.value = locale
      document.documentElement.lang = locale
    },
    { immediate: true }
  )

  watch(
    () => auth.isAuthenticated,
    (authenticated, wasAuthenticated) => {
      if (authenticated) void preferences.load()
      else if (wasAuthenticated) preferences.clear()
    },
    { immediate: true }
  )
}
